import React from 'react';
import { reduxForm, Field, Fields, FieldArray } from 'redux-form';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
import TextField from '../FormElements/TextField';
import LangField from '../FormElements/LangField';
import RenderContentFields from '../FormElements/RenderContentFields';
import RenderCategoriesFields from '../FormElements/RenderCategoriesFields';
import validation from '../../tools/validation';
import i18n from '../../internationalization/i18n';

const validationRules = [validation.required, validation.maxLength(30)];

const propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
  langs: PropTypes.array.isRequired,
  fieldTypes: PropTypes.array.isRequired,
  defaultLang: PropTypes.object.isRequired,
};

const BaseModuleEditForm = ({ handleSubmit, lang, langs, fieldTypes, defaultLang }) => (
  <form className="c-bb-form__container c-bb-form__base-module-entity-form" onSubmit={handleSubmit} >
    <div className="c-bb-form__block">
      <div className="c-bb-form__group">
        <Fields
          names={langs.map(item => `label_${item.code}`)}
          component={LangField}
          lang={lang}
          label={i18n.t('CONTENT.name')}
        />
        <Field
          name="internalName"
          component={TextField}
          addClassName={(lang !== defaultLang.code) ? 'c-bb-form__input--disabled' : ''}
          disabled={lang !== defaultLang.code}
          label={i18n.t('CONTENT.workName')}
          validate={validationRules}
        />
        <div className="c-bb-form__input" />
      </div>
    </div>

    <FieldArray
      name="fields"
      lang={lang}
      langs={langs}
      defaultLang={defaultLang}
      fieldTypes={fieldTypes}
      component={RenderContentFields}
    />

    <FieldArray
      name="categories"
      lang={lang}
      langs={langs}
      defaultLang={defaultLang}
      component={RenderCategoriesFields}
    />

    <button
      className="c-bb-form__submit c-bb-button--primary c-bb-button"
      style={{ marginTop: '40px' }}
      type="submit"
    >
      {i18n.t('CONTENT.save').toUpperCase()}
    </button>
  </form>
);

BaseModuleEditForm.propTypes = propTypes;

const validateForm = (values, { langs }) => {
  const errors = {
    languages: [],
  };

  const messages = {
    required: 'required',
  };

  const isValidName = (name) => {
    if (!name) {
      return false;
    }

    return String(name).trim().length > 0;
  };

  langs.map((lang) => {
    const key = `label_${lang.code}`;
    const name = get(values, key);

    if (!isValidName(name)) {
      errors.languages.push(lang.code);
      errors[key] = messages.required;
    }

    return lang;
  });

  const internalNames = [];
  errors.fields = Array.from(values.fields || []).map((field) => {
    const fieldErrors = { label: {} };

    if (field && field.internalName) {
      if (internalNames.includes(field.internalName)) {
        fieldErrors.internalName = 'unique';
      }
      internalNames.push(field.internalName);
    }

    if (!field || !field.label || Object.keys(field.label).length < langs.length) {
      langs.forEach((lang) => {
        const name = get(field, `label.${lang.code}`);
        if (!isValidName(name)) {
          errors.languages.push(lang.code);
          fieldErrors.label[lang.code] = messages.required;
        }
      });

      return fieldErrors;
    }

    Object.keys(field.label).forEach((langKey) => {
      const name = field.label[langKey];
      if (!isValidName(name)) {
        errors.languages.push(langKey);
        fieldErrors.label[langKey] = messages.required;
      }
    });

    return fieldErrors;
  });

  const validateCategory = (category) => {
    const categoryErrors = { title: {}, children: { categories: {} } };
    langs.forEach((lang) => {
      const name = get(category, `title.${lang.code}`);
      if (!isValidName(name)) {
        errors.languages.push(lang.code);
        categoryErrors.title[lang.code] = messages.required;
      }
    });

    categoryErrors.children.categories = Array.from(get(category, 'children.categories', [])).map(validateCategory);

    return categoryErrors;
  };

  errors.categories = Array.from(values.categories || []).map(validateCategory);
  errors.languages = uniq(errors.languages);

  return errors;
};

export default reduxForm({
  form: 'baseModuleForm',
  validate: validateForm,
})(withNamespaces()(BaseModuleEditForm));



// WEBPACK FOOTER //
// ./src/components/BaseModule/BaseModuleEditForm.js